<div class="modal-header">
	<!-- <h2>Google Map</h2> -->
	<!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
		<svg version="1.1" x="0px" y="0px" width="14" height="14" viewBox="0 0 14 14">
			<path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
		</svg>
	</button> -->
</div>
<div class="modal-body">
	<h3>Default Receiving Branch</h3>
	<fieldset class="add-categories pb-4">
		<select 
			app-select2 
			[options]="{
				data: branches,
				idColumn: 'id',
				textColumn: 'name'
			}" 
			[(ngModel)]="selectedBranchId" 
			[ngModelOptions]="{ standalone: true }" 
			data-placeholder="Select Branch"
			class="form-control"
		>
			<option></option>
		</select>
	</fieldset>
</div>
<div class="modal-footer">
	<button type="button" class="tu-btn blue" (click)="confirmBranch()">Confirm</button>
	<button type="button" class="tu-btn pink" (click)="activeModal.dismiss()">Cancel</button>
</div>